export const VIEWSPARK_SESSION_EXPIRED = "viewspark-session-expired";

export function dispatchSessionExpired(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new CustomEvent(VIEWSPARK_SESSION_EXPIRED));
}

export function payloadIndicatesSessionExpired(message: string): boolean {
  if (!message) {
    return false;
  }
  return (
    message.includes("SESSION_EXPIRED") ||
    message.toLowerCase().includes("session has expired")
  );
}

export function notifySessionExpiredFromBody(body: unknown, fallbackText: string): void {
  if (payloadIndicatesSessionExpired(fallbackText)) {
    dispatchSessionExpired();
    return;
  }
  if (body && typeof body === "object" && "message" in body) {
    if (payloadIndicatesSessionExpired(String((body as { message: unknown }).message))) {
      dispatchSessionExpired();
    }
  }
}
